import React from 'react';
import ReactDOM from 'react-dom/client';
import { MantineProvider } from '@mantine/core';
import './fonts.css'; // Manrope (200..800, kirill bilan) — Mantine uslublaridan OLDIN
import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import '@mantine/charts/styles.css';
import '@mantine/notifications/styles.css';
import '@mantine/spotlight/styles.css';
import { Notifications } from '@mantine/notifications';
import { ModalsProvider } from '@mantine/modals';
import { QueryClient, QueryClientProvider, MutationCache, QueryCache } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { notifications } from '@mantine/notifications';
import axios from 'axios';
import App from './App';
import { theme } from './theme';
import { AuthProvider } from './contexts/AuthContext';
import './i18n';
import './index.css';

function errorMessage(error: unknown): string {
  if (axios.isAxiosError(error)) {
    return (error.response?.data as { error?: string })?.error || error.message;
  }
  return (error as Error)?.message || 'Xatolik yuz berdi';
}

const queryClient = new QueryClient({
  queryCache: new QueryCache({
    // Global xato-toast O'QISH so'rovlari uchun. Busiz yiqilgan so'rov sahifada jimgina
    // "ma'lumot yo'q" bo'lib ko'rinardi — foydalanuvchi bo'sh jadvalni haqiqat deb qabul
    // qilardi. Ikki istisno bor:
    //  • 401 — `services/api.ts` interceptor'i allaqachon sessiyani tozalab /login ga
    //    yo'naltiryapti, toast faqat bir zumga chaqnab yo'qolardi;
    //  • `meta: SILENT_ERROR` — sahifa xatoni o'zi ochiq ko'rsatadi (Alert + qayta urinish),
    //    toast o'sha xabarni takrorlamasin.
    onError: (error, query) => {
      if (query.meta?.skipErrorToast) return;
      if (axios.isAxiosError(error) && error.response?.status === 401) return;
      notifications.show({ color: 'red', message: errorMessage(error) });
    },
  }),
  mutationCache: new MutationCache({
    // Global xato-toast — FAQAT o'z onError'i bo'lmagan mutatsiyalar uchun. Aks holda o'z
    // onError'iga ega mutatsiyada ikkita bir xil qizil toast chiqardi (v5 ikkalasini ham chaqiradi).
    onError: (error, _vars, _ctx, mutation) => {
      if (mutation.options.onError) return;
      notifications.show({ color: 'red', message: errorMessage(error) });
    },
  }),
  defaultOptions: {
    queries: { refetchOnWindowFocus: false, staleTime: 30_000, retry: 1 },
    mutations: { retry: 0 },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <MantineProvider theme={theme} defaultColorScheme="light">
      <Notifications position="top-right" autoClose={3500} />
      <ModalsProvider>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <AuthProvider>
              <App />
            </AuthProvider>
          </BrowserRouter>
        </QueryClientProvider>
      </ModalsProvider>
    </MantineProvider>
  </React.StrictMode>
);
